import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import { changeFilter } from '../../actions/photos'
import PhotosFiltering from './../../components/PhotosFiltering'

const mapStateToProps = (state, ownState) => ({
  selected: dotProp.get(state, 'photos.currentFilter', 'all'),
})

const mapDispatchToProps = dispatch => ({
  select: filter => dispatch(changeFilter(filter)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PhotosFiltering)



// WEBPACK FOOTER //
// ./src/containers/PhotosFiltering/index.js